// Updated: 2026-10-30
// Purpose: Bound document imports independently of per-request generation caps.

export const SUPPORTED_SCREENPLAY_EXTENSIONS = [
  "fdx",
  "fountain",
  "txt",
  "pdf",
] as const;
export const MAX_SCREENPLAY_FILE_BYTES = 10 * 1024 * 1024;
export const MAX_SCREENPLAY_BLOCKS = 7_000;
export const MAX_GENERATION_TEXT_CHARACTERS = 500_000;

export const screenplayExtension = (filename: string): string | null => {
  const extension = filename.split(".").pop()?.trim().toLowerCase();
  return extension || null;
};

export const validateScreenplayFile = (
  filename: string,
  sizeBytes: number,
): string | null => {
  const extension = screenplayExtension(filename);

  if (
    !extension ||
    !SUPPORTED_SCREENPLAY_EXTENSIONS.includes(
      extension as (typeof SUPPORTED_SCREENPLAY_EXTENSIONS)[number],
    )
  ) {
    return "Choose a PDF (.pdf), Final Draft (.fdx), Fountain (.fountain), or text (.txt) file.";
  }

  if (!Number.isFinite(sizeBytes) || sizeBytes <= 0) {
    return "The screenplay file is empty.";
  }

  if (sizeBytes > MAX_SCREENPLAY_FILE_BYTES) {
    return "The screenplay file exceeds the 10 MB upload limit.";
  }

  return null;
};

export const validateParsedScreenplaySize = (
  sequence: Array<{ text: string }>,
): string | null => {
  if (sequence.length > MAX_SCREENPLAY_BLOCKS) {
    return `The screenplay contains ${sequence.length.toLocaleString()} blocks; the current limit is ${MAX_SCREENPLAY_BLOCKS.toLocaleString()}.`;
  }

  const totalCharacters = sequence.reduce(
    (total, item) => total + item.text.length,
    0,
  );

  if (totalCharacters > MAX_GENERATION_TEXT_CHARACTERS) {
    return `The screenplay contains ${totalCharacters.toLocaleString()} text characters; the current limit is ${MAX_GENERATION_TEXT_CHARACTERS.toLocaleString()}.`;
  }

  return null;
};
